import AlertDialog, { AlertType } from './AlertDialog';

export { AlertType };

export default AlertDialog;
